import { ref, deleteObject } from 'firebase/storage';
import { storage } from '../config/firebase';

//delete the files from firebase
export default async function deleteFile(file) {
    const storageRef = ref(storage, file);

    deleteObject(storageRef)
        .then(() => {
            console.log('File deleted successfully');
        })
        .catch((error) => {
            console.error('Error deleting file:', error);
        });
}
